import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { SftpImportConfigurationWorkflow, ImportHierarchyOption, getImportHierarchyOptionDescriptions } from '../../../store/Models/Api/SftpImportModels';
import { RadioButtonGroup } from '../../core/RadioButtonGroup';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';

interface ConfigureLevelsPanelLocalProps {
    config: SftpImportConfigurationWorkflow;
}

type ConfigureLevelsPanelProps = ConfigureLevelsPanelLocalProps & ToxnotComponentProperties;

class ConfigureLevelsPanelComponent extends ToxnotComponent<ConfigureLevelsPanelProps> {
    render() {
        const { config, appServices } = this.props;
        const hierarchyOptionDescriptions = getImportHierarchyOptionDescriptions(appServices);

        
        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">{this.localizeString("Configure Levels")}</h3>
                </div>
                <div className="panel-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <h4>{this.localizeString("How should 3E Exchange determine the sub-materials hierarchy in your import?")}</h4>
                    
                    <div className="form-group">
                        <label>{this.localizeString("Is there hierarchy represented in your import?")}</label>
    
                        <RadioButtonGroup<ImportHierarchyOption>
                            options={[
                                ImportHierarchyOption.LevelColumn,
                                ImportHierarchyOption.LevelColumnWithMultipleLevelsPerRow,
                                ImportHierarchyOption.RepeatedMaterialIdentifiers
                            ]}
                            value={config.importHierarchyOptionType}
                            onValueChange={() => {}} // Read-only
                            getFriendlyNameForOptions={(option) => hierarchyOptionDescriptions[option]}
                            isDisabled={true}
                            name="hierarchy-options-readonly"
                        />
                        
                        {(config.importHierarchyOptionType === undefined || config.importHierarchyOptionType === null) && (
                            <div className="alert alert-warning">
                                <strong>{this.localizeString("No hierarchy representation specified.")}</strong>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export const ConfigureLevelsPanel = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ConfigureLevelsPanelComponent);
